export var NAME_REGEX = /^[a-zA-Z0-9&*#();\-@/." ]+$/;
export var PHONE_REGEX = /(\d{3})-?(\d{3})-?(\d{4})/;
export var ZIPCODE_REGEX = /^\d{5}$/;
export var COMPANY_NAME_REGEX = /^[a-zA-Z.*#().\-;@/&0-9' ]+$/;
export var ADDRESS_REGEX = /^[a-zA-Z\d\-_.,!@#$%^()+=? "'\\ :\s]+$/;
export var NUMBERS_REGEX_GLOBAL = /^[0-9]*$/g;
export var EMAIL_REGEX = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;
export var USER_ROLE_REGEX = /Purchaser|Admin|purchaser|admin/;
export var USER_ROLE_WITH_RUNNER_REGEX = /Purchaser|Runner|Admin|purchaser|runner|admin/;
